function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { DateTime, Duration } from 'luxon';
import { LatLng } from 'leaflet';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBarcode, faPlus } from '@fortawesome/free-solid-svg-icons';
import USABMX from '../../../../services/USABMX';
import './EventSelector.css';

var EventSelector = /*#__PURE__*/function (_React$Component) {
  _inherits(EventSelector, _React$Component);

  function EventSelector(props) {
    var _this;

    _classCallCheck(this, EventSelector);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(EventSelector).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "updateEventList", function () {
      var venue = _this.props.venue;

      if (venue) {
        USABMX.getRacesByTracks([venue]).then(function (raceList) {
          var limit = DateTime.fromMillis(new Date().getTime()).plus(Duration.fromObject({
            days: 3
          }));

          _this.setState({
            events: raceList.filter(function (race) {
              return race.begins_on < limit;
            })
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "selectEvent", function (e, event) {
      var _this$props = _this.props,
          logBookEntry = _this$props.logBookEntry,
          onSelect = _this$props.onSelect;
      logBookEntry.event = event;

      if (event.eventName && event.eventName() === 'Practice') {
        logBookEntry.category = 'Practice';
      }

      onSelect(e, logBookEntry);
    });

    _this.state = {
      events: []
    };
    return _this;
  }

  _createClass(EventSelector, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var updateEventList = this.updateEventList;
      updateEventList();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var updateEventList = this.updateEventList;

      if (prevProps.venue !== this.props.venue) {
        updateEventList();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var selectEvent = this.selectEvent;
      var _this$props2 = this.props,
          app = _this$props2.app,
          width = _this$props2.width,
          height = _this$props2.height,
          logBookEntry = _this$props2.logBookEntry,
          onSelect = _this$props2.onSelect;
      var events = this.state.events;
      return React.createElement("div", {
        className: "event-selector",
        style: {
          height: "".concat(height, "px")
        }
      }, React.createElement("div", {
        className: "events",
        style: {
          height: "".concat(height - 50, "px")
        }
      }, events.length === 0 && React.createElement("div", {
        className: "event no-events-found",
        key: 'no-events-found',
        onClick: onSelect
      }, React.createElement("div", {
        className: "name"
      }, "no events found")), events.map(function (event) {
        return React.createElement("div", {
          className: "event ripple ".concat(event.id === logBookEntry.event.id ? 'selected' : ''),
          key: event.id.toString(),
          onClick: function onClick(e) {
            return selectEvent(e, event);
          }
        }, React.createElement("div", {
          className: "name"
        }, event.eventName()), React.createElement("div", {
          className: "date"
        }, event.begins_on.toLocaleString(DateTime.DATE_FULL)));
      })));
    }
  }]);

  return EventSelector;
}(React.Component);

export default EventSelector;